import React from "react";

export const TileList = ({ style, children }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: ".25rem",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
